import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KeybindingDisableService {
  private _disabled = new BehaviorSubject<boolean>(false);

  set disabled(val: boolean) {
    this._disabled.next(val);
  }

  getDisabled(): Observable<boolean> {
    return this._disabled.asObservable();
  }
}
